import React from 'react';
import './spin.css';

const Spinner = (props) => {
  return (
    <div className="spin-box">
      <div className="spin">
        <div className="spinner" />
      </div>
    </div>
  )
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/lib/components/spin.js